import React from "react"
export function BaggageLoss(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g
        id="prefix__Single-Color-Icons"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M13.107 8.24A4.887 4.887 0 0118 13.12c0 2.695-2.19 4.88-4.893 4.88a4.887 4.887 0 01-4.893-4.88c0-2.695 2.19-4.88 4.893-4.88zm0 .915A3.97 3.97 0 009.13 13.12a3.97 3.97 0 003.976 3.965 3.97 3.97 0 003.976-3.965 3.97 3.97 0 00-3.976-3.965zM11.883 2.75a.61.61 0 01.612.61v1.983h3.11c.535 0 .97.416 1.015.942l.004.09v1.253h-.918V6.374a.116.116 0 00-.07-.11l-.032-.006H3.27c-.042 0-.082.031-.096.078l-.006.038v4.305l4.13.001v.915h-4.13v3.39c0 .055.031.097.071.112l.031.005h4.027v.915H3.27c-.536 0-.97-.416-1.015-.942l-.004-.09v-8.61c0-.538.407-.983.931-1.029l.088-.003h3.11V3.36a.61.61 0 01.611-.61h4.893zm2.65 8.31l.649.648-1.411 1.406 1.406 1.404-.65.647-1.406-1.403-1.4 1.397-.648-.647 1.4-1.398-1.405-1.4.649-.647 1.404 1.4 1.412-1.406zm-2.955-7.395H7.296v1.676h4.282V3.665z"
          fill="currentColor"
          fillRule="nonzero"
          id="prefix__baggage-loss"
        />
      </g>
    </svg>
  )
}
